import classNames from 'classnames';
import * as React from 'react';
import styles from 'src/components/assets/simple-table.module.scss';
import { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { asyncPersistInternal } from 'src/store/actions/internal-actions';
import { Dispatch } from 'redux';
import { DateTimePicker } from 'react-widgets';
import { StoreState } from '../../../../../../../../../store/reducers';
import { changeToZeroMoment, changeToZeroZoneDate } from 'src/helpers/timeHelpers';
import Loader from '../../../../../../../../../components/Loader';
import GeneralEnumService from '../../../../../../../../../enumerables/general-enum';
import { toast } from 'react-toastify';

export interface StateProps {
    inProgress: boolean;
}

export interface DispatchProps {
    updateData: (val: any) => Promise<any>;
}

export interface OwnProps {
    columns: { id: string; label: string; type?: string; cellStyle: string }[];
    row: any;
    key: string;
    action: (val: any) => void;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}
export interface State {
    id?: string | number;
    internalDate: Date | undefined;
    description: string;
    amount: number;
    providerId?: string;
    columnForm?: boolean;
    status: { label: string; value: number };
}

class FormColumn extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            id: '',
            description: props.row.description ? props.row.description : '',
            status: { label: 'one', value: 1 },
            amount: props.row.amount ? props.row.amount : 0,
            internalDate: props.row.internalDate ? changeToZeroZoneDate(props.row['internalDate']) : undefined,
        };
    }

    handleChange = (event: ChangeEvent<HTMLInputElement>, name: string) => {
        this.setState({ ...this.state, [name]: event.target.value });
    };
    handleSubmit = async () => {
        let status: any = this.state.status;
        if (this.state.status?.label) {
            status = status?.value;
        }

        if (!+this.state.amount) {
            toast.error('Amount Must be at least 1');
            return null;
        }
        await this.props.updateData({ ...this.state, status, id: this.props.row?.id });
        return this.props.action(false);
    };
    render() {
        const { setOpenDrop, status } = this.props.row;
        const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('InternalStatus') : {};
        const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
        const valueStatus: any = statusItems.find((it) => it.value === status);
        const valueStatusLabel = valueStatus ? valueStatus.label : '';
        const columnChange: any = {
            id: (
                <input
                    type="hidden"
                    className={classNames('form-control', 'input-sm')}
                    onChange={(ev) => this.handleChange(ev, 'id')}
                    value={this.state['id']}
                />
            ),
            internalDate: (
                <div style={{ minWidth: 150, maxWidth: 150 }}>
                    {+valueStatus?.value === +4 ? (
                        changeToZeroMoment(this.props.row?.internalDate, 'MMM D, YYYY')
                    ) : (
                        <DateTimePicker
                            onChange={(date: any) => {
                                this.setState({ ...this.state, internalDate: date });
                            }}
                            disabled={this.props.row?.id && true}
                            value={this.state['internalDate']}
                            time={false}
                            date={true}
                            dropUp
                            onToggle={(isOpen) => {
                                if (isOpen) {
                                    setOpenDrop(true);
                                } else {
                                    setOpenDrop(false);
                                }
                            }}
                            format={'MMM D, YYYY'}
                        />
                    )}
                </div>
            ),
            amount: (
                <div>
                    <input
                        type="number"
                        className={classNames('form-control', 'input-sm')}
                        onChange={(ev) => this.setState({ ...this.state, amount: +ev.target.value })}
                        value={this.state['amount']}
                    />
                </div>
            ),
            status: <div>{valueStatusLabel}</div>,

            action: (
                <div>
                    <button
                        className={classNames(styles.buttonColumn, 'mr-3')}
                        type={'button'}
                        onClick={() => this.handleSubmit()}
                    >
                        <FontAwesomeIcon style={{ color: 'green' }} icon={faCheckCircle} />
                    </button>
                    <button
                        className={classNames(styles.buttonColumn, 'mr-3')}
                        type={'button'}
                        onClick={() => this.props.action(false)}
                    >
                        <FontAwesomeIcon style={{ color: 'red' }} icon={faTimesCircle} />
                    </button>
                </div>
            ),
        };

        columnChange.description = (
            <div style={{ minWidth: 215 }}>
                <textarea
                    className={classNames('form-control', 'input-sm')}
                    onChange={(event) => {
                        this.setState({ ...this.state, description: event.target.value });
                    }}
                    maxLength={255}
                    value={this.state.description}
                />
            </div>
        );
        const isMobile = window.innerWidth <= 800;
        if (isMobile) {
            return (
                <div className={classNames(styles.relative)}>
                    {this.props.columns.map(
                        (column: { id: string; label: string; type?: string; cellStyle: string }, key) => (
                            <div
                                style={{ minHeight: 50, fontSize: 14 }}
                                className={
                                    'border-secondary text-center  d-flex justify-content-center align-items-center border border-bottom-1'
                                }
                                key={`td-${key}`}
                            >
                                {columnChange[column.id]}
                            </div>
                        ),
                    )}
                    <div className={classNames(styles.hide)}>{this.props.inProgress ? <Loader /> : ''}</div>
                </div>
            );
        } else {
            return (
                <tr className={classNames(styles.relative)}>
                    {this.props.columns.map(
                        (column: { id: string; label: string; type?: string; cellStyle: string }, key) => (
                            <td key={`td-${key}`} className={classNames(styles[column.cellStyle])}>
                                {columnChange[column.id]}
                            </td>
                        ),
                    )}
                    <td className={classNames(styles.hide)}>{this.props.inProgress ? <Loader /> : ''}</td>
                </tr>
            );
        }
    }
}
function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.seances.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        updateData: async (data: any) => {
            return await asyncPersistInternal(
                {
                    ...data,
                    provider: ownProps.row.providerId,
                    month: ownProps.row.month,
                    columnForm: true,
                },
                dispatch,
            );
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FormColumn);
